module.exports = __webpack_public_path__ + "img/moe.58dd30e6.png";